import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative flex h-fit w-full max-w-46.5 items-center justify-between justify-end pr-3 whitespace-nowrap normal-case md:max-w-56.25',
    button: 'flex-center mx-auto normal-case',
    label: 'grow-1',
    buttonChildren: 'flex-center w-full gap-2',
    icon: 'group-hover/sort:[&>path]:stroke-brand-400 size-6',
    input: 'h-14 py-0 group-[.shadow-header]:h-9',
    sortButtonLbl:
      'placeholder:text-bg-items-black text-bg--items-black block w-auto cursor-pointer py-0 pr-3 text-base font-light',
    sortButton:
      'group/sort disabled:text-inactive hover:text-brand-400 flex h-14 cursor-pointer items-center justify-end gap-2 bg-transparent p-0 text-base font-light',
    sortArrow: 'size-[24px] transition-transform duration-150',
    sortValueList: 'flex flex-col gap-2',
    sortValue:
      'text-bg-items-black hover:text-brand-400 flex h-11.5 cursor-default items-center justify-center text-base font-light select-none hover:cursor-pointer hover:bg-transparent focus:bg-transparent',
    loading: 'loading transition-opacity'
  },
  variants: {
    open: {
      true: {
        icon: 'rotate-180'
      }
    }
  }
});
